import React from 'react'
import Layout from '../../../../component/layout/Layout'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const AccuFormFormationAnalyzer = () => {

    const settings = {
        dots: true,
        infinite: true,
        speed: 1500,        // ✅ slower transition (2 seconds)
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2500 // ✅ stays 3 seconds before next slide (optional)
    };

    const images = [
         '/img/instruments/AccuForm Formation.png',
        '/img/instruments/AccuForm Formation.png'
    ];

    return (
        <Layout>
            <div className="bread">
                <ul className="collapsed">
                    <li><a href="/">Home</a></li>
                    <li><a href="/paperTesting">Paper Testing</a></li>
                </ul>
            </div>
            <div className="container">
                <div className="section-title text-center" style={{ marginBottom: '2rem' }}>
                    <h1>AccuForm Formation / Floc Analyzer</h1>
                </div>
            </div>
            <section id="portfolio-details" className="portfolio-details" style={{ backgroundColor: 'white', marginBottom: '12rem' }}>
                <div className="container">
                    <div className="row gy-4">
                        <div className="col-lg-8">
                            <div className="portfolio-details-slider swiper">
                                <Slider {...settings}>
                                    {images.map((src, index) => (
                                        <div className="swiper-slide" key={index}>
                                            <div className="img" style={{ alignItems: 'center' }}>
                                                <img src={src} alt="" className="responsive" />
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                                <div className="swiper-pagination"></div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="portfolio-info" style={{ backgroundColor: 'white' }}>
                                <h3 className='pageheading'>AccuForm Formation / Floc Analyzer </h3>
                                <div className='descriptionHead' style={{ textAlign: 'justify' }}>
                                    <p>
                                        The Formation / Floc Analyzer is a stand-alone instrument that provides both a single value industry
                                        standard Formation Index for routine production quality control testing and a separate Floc and Void
                                        Analysis that provides valuable information about the specific sheet formation properties.  The
                                        instrument employs a uniformly calibrated area light source and an extremely high grade scientific
                                        camera to measure the variations in transmitted light due to variation of sheet densities.

                                    </p>

                                    <p>Applications:</p>

                                    <ul style={{ paddingLeft: "20px" }}>
                                        <li>Tissue to 500 gsm BW</li>
                                        <li>Provides quality control Formation Index plus Floc/Void analysis for wet end troubleshooting</li>
                                    </ul>

                                    <a
                                        href="mailto:inst@rmc.in?subject=Inquiry about Fiber Potential Online (FPO)"
                                        style={{ color: '#0d6efd', fontWeight: '600', textDecoration: 'underline' }}
                                    >
                                        More Info
                                    </a>
                                </div>
                            </div>
                            <div className="portfolio-description"></div>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    )
}

export default AccuFormFormationAnalyzer